import { computed, Inject, Injectable } from '@angular/core';
import { INotification } from '../models/notification.model';
import { SignalStore, SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IQueryResponse, QueryState } from 'src/app/core/models/query.model';
import { InterfaceNotificationApiService } from './interface-notification-api.service';
import { queryStateConfig } from 'src/app/config/query.config';
import { filter, from, map, Observable, switchMap, take, tap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { JwtService } from './jwt.service';


const NOTIFICATION_QUERY_STATE: SignalStoreConfig<QueryState<INotification>> = {
  initState: {
    list: [],
    sort: {
      field: 'createdAt',
      direction: 'desc'
    },
    isLoading: false
  }
};

const NOTIFICATION_UNREAD_QUERY_STATE: SignalStoreConfig<QueryState<INotification>> = {
  initState: {
    list: [],
    sort: {
      field: 'createdAt',
      direction: 'desc'
    },
    isLoading: false
  }
};
 const QUERY_RESPONSE_MAP = {
  data: 'data', //'content'
  currentPage: 'meta.currentPage', //'number'
  itemsPerPage: 'meta.itemsPerPage', //'size'
  totalItems: 'meta.totalItems', //'totalElements'
  totalPages: 'meta.totalPages', //'totalPages'
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  endpoint = 'notification';
  store = new SignalStore<QueryState<INotification>>(this.endpoint + '-store', NOTIFICATION_QUERY_STATE);
  unreadStore = new SignalStore<QueryState<INotification>>(this.endpoint + '-store-unread', NOTIFICATION_UNREAD_QUERY_STATE);

  unread = this.unreadStore.selectKey('list');
  unreadCount = computed(() => this.unread().length);
  unreadIds = computed(() =>
    (this.unread()?.map(
      (notification) => notification.id
    ).filter(
      (id): id is number => id !== undefined) ?? [])
    );
  all = this.store.selectKey('list');

  constructor(
     private readonly api: InterfaceNotificationApiService,
     private jwtService:JwtService,
    private http: HttpClient,
  ) { }

  markAllAsRead() {
    this.markAsRead(this.unreadIds());
  }

  getFieldByPath(obj: any, path: string) {
    const keys = path.split('.');
    let result = obj;
    for (const key of keys) {
      if (result.hasOwnProperty(key)) {
        result = result[key];
      } else {
        return undefined; // Ritorna undefined se il campo non esiste
      }
    }
    return result;
  }
  
  markAsRead(notificationIds: number[]) {
    this.api.post('notification/mark-as-read', { ids: notificationIds }).subscribe(() => {
      this.getAll();
      this.getUnread();
    });
  }

  private getStreamHttp(url: string, theStore: SignalStore<QueryState<INotification>>) {
    return new Observable(observer => {
      const token = this.jwtService.getTokenJwt(); // Recupera il token Bearer
      const abortController = new AbortController(); // Permette di interrompere la richiesta
  
      fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept": "text/event-stream"
        },
        signal: abortController.signal
      })
        .then(response => {
          if (!response.body) {
            throw new Error("Errore: Nessun body nella risposta!");
          }
  
          const reader = response.body.getReader();
          const decoder = new TextDecoder();
  
          const readStream = () => {
            reader.read().then(({ done, value }) => {
              if (done) {
                observer.complete();
                return;
              }
  
              const chunk = decoder.decode(value, { stream: true });
              const events = chunk.split("\n\n"); // Divide i messaggi SSE
  
              events.forEach(event => {
                if (event.trim()) {
                  try {
                    const parsedData = JSON.parse(event.replace(/^data:\s*/, "")); // Rimuove "data:" se presente
                    observer.next(parsedData);
                  } catch (error) {
                    console.error("Errore nel parsing JSON:", error);
                  }
                }
              });
  
              readStream(); // Continua a leggere i dati finché lo stream è aperto
            }).catch(error => observer.error(error));
          };
  
          readStream();
        })
        .catch(error => observer.error(error));
  
      return () => {
        console.log("Connessione SSE chiusa");
        abortController.abort(); // Interrompe la richiesta fetch
      };
    });
  }
  

  getStreamData(url: string) {
    this.getStreamHttp(url, this.store).subscribe({
      next: (data) => {
        console.log("Dato ricevuto:", data);
       
      },
      error: (err) => console.error("Errore nello stream:", err),
      complete: () => console.log("Stream completato")
    });
  }
  

  getAll() {
    
    this.get('', this.store);
    console.log(this.store)
  }
  streamTest(url:string){
    this.getNextForm(url, this.store);
  }
  invioForm(dati:any){

   return this.api.post('saveForm',dati)
  }
  getUnread() {
    this.get('notification/unread', this.unreadStore);
  }

  private get(url: string, theStore: SignalStore<QueryState<INotification>>) {
    if (theStore.selectKey('isLoading')() === false) {
      theStore.setKey('isLoading', true);
      const queryParams: any = {
        sort: {
            field: 'createdAt',
            direction: 'desc'
        },
        pageable: {
            size: 9999
        },
        filters: {
            channel: '$eq:app',
            status: '$eq:process',
            notifiable: `$ilike:"id":2,`
        }
    };
   const defaultConfig = queryStateConfig;
      this.api.get<IQueryResponse>(url).subscribe((response) => {
        console.log(response)
        theStore.setKey('list', this.getFieldByPath(response, QUERY_RESPONSE_MAP.data));
        theStore.setKey('pageable', {
          page: this.getFieldByPath(response, QUERY_RESPONSE_MAP.currentPage),
          size: this.getFieldByPath(response, QUERY_RESPONSE_MAP.itemsPerPage),
          totalElements: this.getFieldByPath(response, QUERY_RESPONSE_MAP.totalItems),
          totalPages: this.getFieldByPath(response, QUERY_RESPONSE_MAP.totalPages),
        });
      })
    }
  }

  private getNextForm(url: string, theStore: SignalStore<QueryState<INotification>>) {

      this.api.get<IQueryResponse>(url).subscribe((response) => {
        console.log(response)
        
      })
    
  }
}
